module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Collection of Sand: Essays")]), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "brandingPartNum",
    attrs: {
      "id": "col0000090"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('div', {
    staticClass: "hrframe",
    attrs: {
      "id": "col0000091"
    }
  }, [_c('div', {
    staticClass: "hr",
    attrs: {
      "id": "col0000092"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "EB04SmallCapsMainHead2",
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("EXHIBITIONS—EXPLORATIONS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a5fbcab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part001.vue
// module id = 72
// module chunks = 0